<template lang="pug">
#graficoProdutividadeMedia
    div(v-show='possuiDadosHistoricos')
        apex-charts.component.apexcharts-canvas(
            type='bar',
            height='300',
            :options='options',
            :series='series',
            ref='chart'
        )

    div(v-show='!possuiDadosHistoricos')
        empty-result(
            :min-height='150',
            icon-class='mdi-alert-octagon',
            message='Ainda não foram obtidos dados históricos de cultivo para a cultura selecionada.'
        )
</template>

<script>
import ApexCharts from 'vue-apexcharts';
import EmptyResult from '@/components/EmptyResult';

import SelectCultura from '@/components/SelectCultura';

import formatters from '@/utils/formatters';

export default {
    name: 'GraficoProdutividadeMedia',
    components: {
        ApexCharts,
        EmptyResult,
        SelectCultura
    },
    props: {
        dadosHistorico: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            series: [],
            options: {
                legend: {
                    onItemClick: {
                        toggleDataSeries: true
                    }
                },
                chart: {
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        columnWidth: '25%'
                    }
                },
                xaxis: {
                    categories: []
                },
                // colors: ['#8B4513', '#01A3A4', 'var(--secondary-font-color)'],
                // colors: ['#a0cb85', '#ffbb5c', '#b09eb7', '#5e97b5'],
                colors: [
                    'var(--soja-color)',
                    'var(--milho-color)',
                    '#b7a9ae',
                    '#DC610D'
                ],
                stroke: {
                    width: 2
                },
                yaxis: [
                    {
                        showAlways: true,
                        seriesName: 'Produtividade',
                        title: {
                            text: 'Produtividade (sc/ha)'
                        },
                        labels: {
                            formatter: value => {
                                return value.toFixed(0);
                            }
                        },
                        min: 0,
                        max(max) {
                            return max + 10;
                        }
                    }
                ],
                tooltip: {
                    y: {
                        formatter: value => {
                            return formatters.formatNumber(value, 2) + ' sc/ha';
                        }
                    }
                },
                dataLabels: {
                    style: {
                        colors: ['#333', '#333', '#333', '#333']
                    },
                    formatter: value => {
                        return formatters.formatNumber(value, 2);
                    },
                    enabled: true
                }
            }
        };
    },

    mounted() {
        this.updateGrafico();
    },

    methods: {
        updateGrafico() {
            this.createCategories();

            this.createSeries();

            if (this.$refs.chart) {
                this.$refs.chart.updateOptions(this.options);
            }
        },

        createCategories() {
            this.options.xaxis.categories = this.dadosHistorico.map(
                d => d.safra.descricao
            );
        },

        createSeries() {
            let series = [];

            // let nomesCulturas = new Set(this.dadosHistorico.map(d => d.cultura.nome).sort().reverse());
            // Desculpa =(
            let nomesCulturas = ['Soja', 'Milho', 'Algodão', 'Outros'];
            nomesCulturas.forEach(nomeCultura => {
                let dadosPorCultura = this.dadosHistorico.map(d => {
                    const historicoCultura = d.historicosAgro.find(
                        h => h.cultura.nome === nomeCultura
                    );
                    if (historicoCultura) {
                        return historicoCultura.produtividadeEstimadaSacasHa;
                    }
                    return 0.0;
                });
                series.push({
                    name: nomeCultura,
                    type: 'column',
                    data: dadosPorCultura
                });
            });

            this.series = series;
        }
    },

    watch: {
        dadosHistorico() {
            this.updateGrafico();
        }
    },

    computed: {
        possuiDadosHistoricos() {
            return this.dadosHistorico && this.dadosHistorico.length > 0;
        }
    }
};
</script>

<style scoped></style>
